var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YearSelector',{on:{"select":_vm.select}}),_c('OnlineWeekly',{attrs:{"year":_vm.year}}),_c('DelivWeekly',{attrs:{"year":_vm.year}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }